import React, { useState } from 'react'
import { Heading, Text, Button, InlineLink } from '@primer/react-brand'
import ChromelessAuthLayout from '../components/ChromelessAuthLayout'

// WHERE BOTH EMAILED LINKS LAND — sign-up verification and sign-in (Cameron,
// 2026-09-13). See docs/superpowers/specs/2026-09-13-civic-lens-passwordless-access-design.md.
//
// The link only opens this page; the button spends it. Corporate mail filters
// open every link in a message to scan it, and a single-use link spent by a
// scanner is a sign-in the person never gets — so nothing happens on load.
const SignInLinkPage = ({ token, redirectTo, signInPath = '/sign-in' }) => {
  const [loading, setLoading] = useState(false)
  const [failure, setFailure] = useState(null)

  const handleContinue = async () => {
    setLoading(true)
    setFailure(null)

    try {
      const response = await fetch('/api/v1/auth/redeem_link', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        },
        credentials: 'same-origin',
        body: JSON.stringify({ token, redirect_to: redirectTo })
      })
      const data = await response.json()

      if (data.success) {
        window.location.href = data.redirect_to || '/home'
        return
      }
      setFailure(data.reason === 'inactive' ? 'inactive' : 'invalid_link')
    } catch (err) {
      setFailure('general')
    }
    setLoading(false)
  }

  if (!token || failure === 'invalid_link') {
    return (
      <ChromelessAuthLayout>
        <Heading as="h1" size="5">This link has expired</Heading>
        <Text size="200" variant="muted" as="div" style={{ marginTop: '14px' }}>
          Sign-in links work once, and expire soon after they're sent. Request a new one to continue.
        </Text>
        <Text size="200" variant="muted" as="div" style={{ marginTop: '22px' }}>
          <InlineLink href={signInPath}>Get a new sign-in link</InlineLink>
        </Text>
      </ChromelessAuthLayout>
    )
  }

  if (failure === 'inactive') {
    return (
      <ChromelessAuthLayout>
        <Heading as="h1" size="5">This account can't sign in</Heading>
        <Text size="200" variant="muted" as="div" style={{ marginTop: '14px' }}>
          If you think this is a mistake, contact us at{' '}
          <InlineLink href="mailto:support@civiclens.dev">support@civiclens.dev</InlineLink>.
        </Text>
      </ChromelessAuthLayout>
    )
  }

  // 480px, not the default 360, so the heading holds one line (420 still wrapped).
  return (
    <ChromelessAuthLayout maxWidth={480}>
      <Heading as="h1" size="5">You're signing into CivicLens</Heading>

      <Button
        type="button"
        variant="primary"
        block={true}
        disabled={loading}
        onClick={handleContinue}
        style={{
          marginTop: '28px',
          backgroundColor: 'var(--base-color-scale-blue-5)',
          borderColor: 'var(--base-color-scale-blue-5)',
          borderRadius: '6px'
        }}
      >
        {loading ? 'Signing in...' : 'Continue to CivicLens'}
      </Button>

      {failure === 'general' && (
        <p style={{ marginTop: '12px', color: 'var(--brand-color-error-fg)', fontSize: '14px' }}>
          Something went wrong. Please try again.
        </p>
      )}
    </ChromelessAuthLayout>
  )
}

export default SignInLinkPage
